<template>
  <el-form label-width="110px" :model="form" :rules="rules">
    <div class="m-b-10">功能点配置</div>
    <el-form-item label="功能点类型">
      <el-select v-model="form.type" placeholder="功能点类型" class="w-150">
        <el-option v-for="item in operationTypes" :label="item.title" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="功能点名称">
      <el-input v-model.trim="form.name" class="w-150" placeholder="功能点名称"></el-input>
    </el-form-item>
    <el-form-item label="表单" prop="model_id">
      <el-select v-model="form.model_id" placeholder="表单" class="w-150" @change="formChange">
        <el-option v-for="item in models" :label="item.title" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="绑定权限规则">
      <el-input v-model.trim="form.rule_name" class="h-40 fl w-150 m-r-10" :disabled="true" placeholder="绑定权限规则"></el-input>
      <el-button size="small" class="fl" @click="openRule(form)">查找</el-button>
      <el-button size="small" class="fl m-l-5" @click="clearRule()">清空</el-button>
    </el-form-item>
    <el-form-item label="提醒信息" v-if="form.type === OPERATION_IFRAME">
      <el-input v-model.trim="form.rule_name" class="h-40 fl w-150 m-r-10" :disabled="true" placeholder="请绑定权限标识"></el-input>
      <el-button size="small" class="fl m-l-10" @click="openRule(form)">查找</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import http from '../../../assets/js/http'
  import cmsConfig from '../../../config/cmsConfig'
  export default {
    props: {
      form: {
        type: Object,
        default() {
          return {}
        }
      },
      models: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        rules: {
          model_id: [
            { required: true, message: '请绑定表单' }
          ]
        },
        operationTypes: [ // 操作类型数组
          { id: 10, title: '列表' },
          { id: 20, title: '添加/编辑/详情' },
          // { id: 30, title: '编辑' },
          // { id: 40, title: '详情' },
          { id: 50, title: '删除' },
          { id: 60, title: '导入' },
          { id: 70, title: '导出' },
          { id: 80, title: '搜索' },
          { id: 90, title: '一键修改字段值' },
          { id: 100, title: '筛选标签' },
          { id: 110, title: '下载' },
          { id: 120, title: '消息提醒' },
          { id: 130, title: '图表' },
          { id: 140, title: '字段扩展管理' },
          { id: 150, title: '执行函数' },
          { id: 160, title: '外部链接iframe' },
          { id: 170, title: '导出word文档' },
          { id: 180, title: '定制化功能点' },
          { id: 190, title: '批量添加子数据' },
          { id: 200, title: '批量编辑' },
          { id: 210, title: '一维统计图表' },
          { id: 220, title: '功能点链接集合' },
          { id: 230, title: '发邮件' }
        ],
        moduleTypes: [
          { id: 10, title: '公共模块' },
          { id: 20, title: '私有模块' }
        ]
      }
    },
    methods: {
      openRule(item) {
        this.$emit('openRule', item)
      },
      clearRule() {
        this.form.rule_name = ''
        this.form.rule_id = null
      },
      formChange() {
        this.$emit('formChange')
      }
    },
    mixins: [cmsConfig, http]
  }
</script>
<style scoped>
  .downloadBtn{
    padding:5px 10px;
    border: 1px solid #20a0ff;
    color: #fff;
    background-color: #20a0ff;
    font-size: 12px;
    border-radius: 4px;
  }
  .downloadBtn:hover{
    border: 1px solid #4db3ff;
    background-color: #4db3ff;
  }
</style>



// WEBPACK FOOTER //
// dealForm.vue?83d6d014